module.exports = __webpack_public_path__ + "static/media/handbook_confirmation.c45615ef.pdf";